import warn from './utils/warn'

const TagManager = {
    initialize: function ({
        gtmId = '',
        dataLayer = {},
        dataLayerName = 'dataLayer',
        auth = '',
        preview = '',
        domain = 'www.googletagmanager.com',
        tagId = 'nx-google-tag-manager'
    }) {
        if (!gtmId) {
            warn('GTM Id is required')
            return
        }
        // check if already executed
        if (!document.getElementById(tagId)) {
            // execute tag manager load script, gtm loader is not included as script tag as it would require unsafe-inline
            window[dataLayerName] = window[dataLayerName] || []
            window[dataLayerName].push({'gtm.start': new Date().getTime(), event: 'gtm.js'})
            const tag = 'script'
            const firstScript = document.getElementsByTagName(tag)[0]
            const gtmScript = document.createElement(tag)
            const dataLayerParam = dataLayerName != 'dataLayer' ? '&l=' + dataLayerName : ''
            const authParam = auth ? '&gtm_auth=' + auth : ''
            const previewParam = preview ? '&gtm_preview=' + preview : ''
            gtmScript.id = tagId
            gtmScript.async = true
            gtmScript.src = `https://${domain}/gtm.js?id=${gtmId}${dataLayerParam}${authParam}${previewParam}&gtm_cookies_win=x`
            if (firstScript) {
                firstScript.parentNode.insertBefore(gtmScript, firstScript)
            } else {
                document.head.appendChild(gtmScript)
            }
            // push initial dataLayer if provided
            if (dataLayer) {
                window[dataLayerName].push(dataLayer)
            }
        }
    },
    sendEvents: function ({events, dataLayerName = 'dataLayer'}) {
        window[dataLayerName] = window[dataLayerName] || []
        if (events[0] && events[0].ecommerce) {
            window[dataLayerName].push({ecommerce: null})
        }
        window[dataLayerName].push(...events)
    }
}

export default TagManager
